import { api } from "./axios"; // Assuming api is your axios instance

export const dspApi = {
  // Add DSP to the database
  addDSP: (data: {
    name: string;
    email: string;
    password: string;
    type: string;
    // userId: string;
  }) => api.post(`/dsp/connect/${data.type}`, data),

  // Get all DSP records from the database
  getDSPs: () => api.get("/dsp/all"),

  // Delete DSP by ID and type
  deleteDSP: (dspId: number, dspType: string) => {
    return api.delete(`/dsp/delete/${dspId}`, {
      data: { dspType }, // Send dspType in the request body
    });
  },

  // Update DSP details in the database
  updateDSP: (
    userId: string,
    data: {
      name?: string; // Make name optional for partial updates
      email?: string; // Make email optional for partial updates
      password?: string; // Optional, only required for password update
      type: string;
      // userId: string;
    }
  ) => api.put(`/dsp/update/${userId}`, data), // Assuming the endpoint is '/dsp/{id}'

  getDspById: (id: string) => api.get(`/dsp/userdsp/${id}`),
};
